import React from 'react'
import LoginForm from "../components/LoginForm/Loginform"

const LoginPage = () => {
  return (
    <LoginForm />
  )
}

export default LoginPage